<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- <div class="welcom">
      <div class="container-box">您好！欢迎登录大理白族自治州人民医院</div>
    </div> -->
    <!-- 顶部logo -->
    <div class="header-top container-fuild">
      <div class="container-box header-top-container">
        <div class="server pull-left">
          <img src="https://guanwang-1429605986.cos.ap-guangzhou.myqcloud.com/static/img/logoNew.png" alt="" v-animate-on-scrollL/>
          <!-- 菜单 -->
          <div class="header-nav" v-animate-on-scrollD>
            <!-- 导航内容 -->
            <ul class="header-nav-wrapper">
              <li
                v-for="(item, index) in navList"
                :key="index"
                v-if="item.status == '0'"
                :class="index == navIndex ? 'active nav-item' : 'nav-item'"
                
              >
              <!-- @click="navClick(index, item.name)" -->
                <!-- 有子模块 -->
                <router-link
                  :to="{
                    name: item.path.slice(1),
                    query: {
                      key: item.children[0].path,
                      parentValue: item.value,
                      value: item.children[0].value
                    }
                  }"
                  v-if="item.children && item.children.length"
                >
                  <span>{{ item.name }}</span>
                  <span
                    v-if="item.children.length > 0"
                    class="glyphicon glyphicon-menu-down"
                  ></span>
                </router-link>
                <!-- 无子模块 -->

                <router-link
                  :to="{
                    path: item.path,
                    // query: { parentValue: item.value }
                  }"
                  v-else
                >
                  <span>{{ item.name }}</span>
                  <!-- <span
                    v-if="item.children.length > 0"
                    class="glyphicon glyphicon-menu-down"
                  ></span> -->
                </router-link>
                 <span class="cube" v-animate-on-scroll1></span>
                <dl v-if="item.children.length > 0">
                  <dt v-for="(i, n) in item.children" :key="n" v-if="i.status == '0'">
                    <router-link
                      :to="{
                        name: item.path.slice(1),
                        query: {
                          key: i.path,
                          parentValue: item.value,
                          value: i.value
                        }
                      }"
                      style="display: block;width: 100%;height: 100%"
                    >
                      {{ i.name }}
                    </router-link>
                    <!-- <span style="display: block;width: 100%;height: 100%" @click="linkPath(item,i)">
                      {{i.name}}</span> -->
                  </dt>
                </dl>
              </li>
            </ul>
          </div>
        </div>
        
        <div class="pull-right" v-animate-on-scrollR style="width:250px">
          <div class="phone">
           <!-- <i class="el-icon-phone-outline" style="margin-right: 10px;"></i> -->
            <img src="https://guanwang-1429605986.cos.ap-guangzhou.myqcloud.com/static/img/phone.png" alt="" />
            <p>联系电话：0871-63196719</p>
          </div>
         
        </div>
      </div>
    </div>
    
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { getToken } from "../utils/auth";
import { menuLs,getHomeMenu} from "@/api/home.js";
// import { indexMenuSort, indexMenu, menuLs } from "@/api/home.js";
export default {
  name: "Header",
  data() {
    return {
      getToken,
      dialog: false,
      url: this.$router.resolve({ name: "Login" }).href,
      navIndex: sessionStorage.getItem("navIndex")
        ? sessionStorage.getItem("navIndex")
        : 0,
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
        {
          name: "首页",
          value: "home",
          path: "/home",
          children: [],
          status: "0"
        },
        {
          name: "产品与解决方案",
          value: "solution",
          path: "/solution",
          children: [],
          status: "0"
        },
        {
          name: "服务能力",
          value: "service",
          path: "/service",
          children: [],
          status: "0"
        },
        {
          name: "关于我们",
          value: "aboutUs",
          path: "/aboutUs",
          children: [],
          status: "0"
        },
        // {
        //   name: "ces",
        //   value: "test",
        //   path: "/test",
        //   children: [],
        //   status: "0"
        // },
      ]
    };
  },
  computed: {
    ...mapGetters(["token", "avatar", "userName"])
  },
  watch: {
    $route: {
      async handler(val) {
        if (val) {
          let path = "/" + val.name;
          // if (this.navList.length == 1) {
          //   // await this.getFirtsMenu();
          // }
          // await this.getMenuLs();
          // 有路径直接根据路径匹配，没有路径则根据parentValue匹配
          let index = this.navList.findIndex(r => r.path === path);
          if (index !== -1) {
            this.navIndex = index;
          } else {
            index = this.navList.findIndex(
              r => r.value === val.query.parentValue
            );
            this.navIndex = index;
          }
        }
      },
      immediate: true
    }
  },
  async created() {
    // await this.getFirstMenu();
  },
  methods: {
    
    // 查询一级菜单
    // async getFirstMenu() {
    //   await indexMenuSort().then(res => {
    //     if (res.data && res.data.length) {
    //       res.data.forEach(el => {
    //         if (el.status === "0") {
    //           this.navList.push({
    //             name: el.dictLabel,
    //             value: el.dictValue,
    //             path: "/home",
    //             children: []
    //           });
    //         }
    //       });
    //       this.getSecondMenu();
    //     }
    //   });
    // },
    // 查询二级菜单
    // getSecondMenu() {
    //   indexMenu().then(res => {
    //     if (res.data) {
    //       let arr = [];
    //       this.navList.forEach(el => {
    //         if (el.value && res.data[el.value]) {
    //           arr.push({
    //             ...res.data[el.value],
    //             path: "/" + res.data[el.value].path
    //           });
    //         } else {
    //           arr.push(el);
    //         }
    //       });
    //       this.navList = arr;
    //     }
    //   });
    // },
    modifyFunc(node) {
      // node.hasChildren = false;
      // if (node.daliMenuSonList && node.daliMenuSonList.length > 0) {
      //   node.hasChildren = true;
      // }
      const {
        sysDictDataList,
        dictLabel,
        dictPath,
        dictValue,
        dictType,
        deptId
      } = node;

      return {
        ...node,
        children: sysDictDataList,
        name: dictLabel,
        path: "/" + dictPath,
        value: dictValue || deptId,
        dictType
      };
    },
    wfs(node) {
      const newNode = this.modifyFunc(node);
      if (!newNode.sysDictDataList || newNode.sysDictDataList.length == 0) {
        return newNode;
      }
      newNode.children = node.sysDictDataList.map(item => this.wfs(item));
      return newNode;
    },
    // 获取菜单
    getMenuLs() {
      menuLs().then(res => {
        // 遍历树 更改字段
        const arr = res.data.data;
        const ls = arr.map(item => this.wfs(item));
        this.navList = [
          {
            name: "首页",
            value: "home",
            path: "/home",
            children: [],
            status: "0"
          },
          ...ls
        ];
      });
      var bannerList=sessionStorage.getItem("bannerList")?JSON.parse(sessionStorage.getItem("bannerList")):[]
      if(bannerList.length==0){
        getHomeMenu({grade: "1"}).then(res=>{
          if(res.code==200){
            sessionStorage.setItem("bannerList",JSON.stringify(res.data.data))
          }else{
            sessionStorage.setItem("bannerList",[])
          }
        })
      }
      
    },
    // 跳转个人中心
    navToPerson() {
      this.navIndex = -1;
      this.$router.push({ path: "/personCenter" });
    },
    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem("navIndex", index);
      this.menuName = name;
    }
  }
};
</script>
<style scoped lang="less">
.glyphicon-menu-down:before {
  content: "";
}
.container-fuild {
  background: #fff;
}
#header .header-nav .header-nav-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: 68px;
  margin: 0;
  .cube{
    display: none;
    width: 100%;
    height: 3px;
    background-color: #1461cc;
    position: absolute;
    // transition: all 0.8s ease;
    bottom: 0px;
    left: 0;
    border-radius: 5px;
    // animation-name: zoomIn;
    // animation-duration: 2s;
    // animation-delay: 1s;
    // animation-fill-mode:forwards;
  }
}
#header .header-nav .header-nav-wrapper > li > dl {
  width: 126px !important;
  left: -20px !important;
}
#header .header-nav .header-nav-wrapper > li > dl > dt {
  border: none !important;
  text-align: center;
  a {
    color: rgba(0, 0, 0, 0.6) !important;
  }
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  background: #e6f2ff00 !important;
  border: none !important;
  a {
    color: #1461cc !important;
  }
}
.lang.el-menu {
  background: transparent;
  border: none;
}
.lang.el-menu:hover {
  background: transparent;
  border: none;
}
/* 顶部 */
#header {
  transition: all ease 0.6s;
  background: #fff;
  position: sticky;
  top: 0;
  z-index: 99;
  .server{
    display: flex;
    align-items: center;
    img{
      padding: 7px 0 ;
      height:50px;
    }
  }
}
#header .header-top {
  font-size: 12px;
  line-height: 50px;
  background-color: #fff;
  // height: 140px;
  // border-bottom: 1px solid #e4e9f2;
  overflow: hidden;
  .header-top-container {
    // padding: 10px 0 0;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    align-items: center;
    
  }
}
.phone{
  font-size: 15px;
  color: #666;
  display: flex;
  align-items: center;
  img{
    margin-right: 5px;
    width: 20px;
    height:20px;
  }
  p{
    white-space: nowrap;
    margin-bottom: 0;
  }
}
/* 导航栏 */
#header .header-nav {
  // height: 68px;
  // padding: 10px 0;
  margin-left: 20px;
  
}
/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}

/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  padding: 0 10px;
  margin: 0 20px;
  position: relative;
  cursor: pointer;
  height: 100%;
  line-height: 68px;
  box-sizing: border-box;
}
/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  font-weight: 400;
  font-size: 18px;
  color: rgba(0, 0, 0, 0.60);
  // height: 48px;
  padding:5px 0 10px;
  line-height: 48px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  display: block;
  list-style: none;
}
/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  color: #1e73be;
}
/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 18px;
  transition: transform ease 0.5s;
  letter-spacing: 3px;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  /*color: #1e73be;*/
  color: rgba(36, 105, 242, 1);
  /*background-color: #0099E5;*/
  text-decoration: none;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}
#header .header-nav .header-nav-wrapper > li.active {
  display: flex;
  justify-content: space-between;
  .cube{
    display: block;
  }
}
#header .header-nav .header-nav-wrapper > li:hover {
  font-weight: 600;
  color: #1461cc;
  .cube{
    display: block;
  }
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  /*color: #1e73be;*/
  color: #1461cc;
  // font-weight: 600 !important;
  // font-size: 20px !important;
  text-decoration: none;
  /*border-bottom: 2px solid #1e73be;*/
}
/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  width: 168px;
  top: 69px;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 5px 1px #d8d8d8;
  background: #fff;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #ccc;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #606266;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  text-decoration: none;
}
/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: block;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  background: #ccc;
}
.welcom {
  height: 40px;
  background: #f0f2f5;
  color: #909399;
  line-height: 40px;
  padding: 0 20px;
  box-sizing: border-box;
}

@media (max-width: 1200px) {
  #header .header-nav .header-nav-wrapper > li > a > span{
    font-size: 18px;
  }
  
}
@media (max-width: 995px) {
  .header-nav.container {
      width: 100%;
  }
  #header .header-nav .header-nav-wrapper > li > a > span{
    font-size: 18px;
  }
}
@media (max-width: 940px) {
  #header .header-nav .header-nav-wrapper > li > a > span{
    font-size: 16px;
  }
}
@media (max-width: 900px) {
  #header .header-nav .header-nav-wrapper > li > a > span{
    font-size: 20px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Header.vue